
<template>
  <div class="content">
    <div class="btn1" @click="goClass">立即分享</div>
  </div>
</template>

<script>
export default {
  name: "testGold",
  data() {
    return {};
  },
  methods: {
    goClass() {
      this.$router.push("./../class");
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  width: 100vw;
  height: 640vw;
  background-image: url("./../../../assets/img/test/backgold.png");
  background-repeat: no-repeat;
  background-size: contain;
  text-align: center;
  position: relative;

  .btn1 {
    background: linear-gradient(to left, #fe6f28, #f6a624);
    width: 82vw;
    height: 45px;
    border-radius: 18px;
    margin-left: 9vw;
    position: absolute;
    text-align: center;
    line-height: 45px;
    font-size: 18px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #ffffff;
    top: 613vw;
  }
}
</style>

